import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { scaleTime } from "d3-scale";
import { discontinuousTimeScaleProviderBuilder } from "react-stockcharts/lib/scale";
import { ChartCanvas, Chart } from "react-stockcharts";
import { AreaSeries, BarSeries } from "react-stockcharts/lib/series";
import { XAxis, YAxis } from "react-stockcharts/lib/axes";
import { fitWidth } from "react-stockcharts/lib/helper";
import { last, first } from "react-stockcharts/lib/utils";
// import { Brush } from "react-stockcharts/lib/interactive";
import {
  getNewChartConfig,
  getChartConfigWithUpdatedYScales,
  getCurrentCharts,
  getCurrentItem
} from "react-stockcharts/lib/utils/ChartDataUtil";

import {
  InteractiveYCoordinate,
  ClickCallback
} from "react-stockcharts/lib/interactive";

import Slider from "rc-slider";

const Range = Slider.Range;

const Container = styled.div`
  position: relative;
`;

// const Layer = styled.div`
//   position: absolute;
//   top: 0;
//   left: 20px;
//   right: 40px;
//   z-index: 999999999999;
//   height: 60px;
// `;

const rgba = (rgb, opacity = 1) => `rgba(${rgb},${opacity})`;

class PreviewChart extends React.Component {
  static defaultProps = {
    textColor: "20, 98, 125, 1",
    lineColor: "20, 98, 125, 1",
    axisColor: "20, 98, 125, 1"
  };

  static propTypes = {
    data: PropTypes.array.isRequired,
    width: PropTypes.number.isRequired,
    ratio: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      ...this.getChartState(props.data, 0)
    };
  }

  getChartState = (chartData, initialIndex) => {
    const xScaleProvider = discontinuousTimeScaleProviderBuilder()
      .initialIndex(initialIndex)
      .inputDateAccessor(d => d.date);

    return {
      initialIndex,
      ...xScaleProvider(chartData)
    };
  };

  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  render() {
    console.log("render");
    const { type, width, ratio } = this.props;
    const { data, xScale, xAccessor, displayXAccessor } = this.state;

    const margin = { left: 20, right: 40, top: 0, bottom: 0 };

    const height = 60;
    const gridHeight = height - margin.top - margin.bottom;
    const gridWidth = width - margin.left - margin.right;

    const showGrid = true;
    const yGrid = showGrid ? { innerTickSize: -1 * gridWidth } : {};
    const xGrid = showGrid ? { innerTickSize: -1 * gridHeight } : {};

    return (
      <Container>
        <div style={{ position: "absolute" }}>
          <svg>
            <defs>
              <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop
                  offset="0%"
                  stopColor={rgba(this.props.lineColor)}
                  stopOpacity=".4"
                />
                <stop
                  offset="30%"
                  stopColor={rgba(this.props.lineColor)}
                  stopOpacity=".2"
                />
                <stop
                  offset="100%"
                  stopColor={rgba(this.props.lineColor)}
                  stopOpacity="0"
                />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <ChartCanvas
          ref={node => {
            this.node = node;
          }}
          ratio={ratio}
          width={width}
          height={height}
          margin={margin}
          seriesName="MSFT"
          data={data}
          type="svg"
          xScale={xScale}
          xAccessor={xAccessor}
          displayXAccessor={displayXAccessor}
          mouseMoveEvent={false}
          panEvent={false}
          zoomEvent={false}
          clamp={false}
        >
          <Chart
            id={0}
            yExtents={d => d.close}
            padding={{ top: 5, right: 0, bottom: 5, left: 0 }}
          >
            <XAxis
              fontFamily="Roboto Condensed"
              axisAt={59}
              orient="bottom"
              {...xGrid}
              stroke={rgba(this.props.axisColor)}
              ticks={6}
              tickPadding={-15}
              tickStrokeWidth={1}
              outerTickSize={0}
              tickStrokeDasharray={"ShortDash"}
              tickStrokeOpacity={0.3}
              tickStrokeWidth={1}
              tickStroke={rgba(this.props.textColor)}
              zoomEnabled={false}
            />

            <AreaSeries
              yAccessor={d => d.close}
              fill="url(#grad1)"
              stroke={rgba(this.props.lineColor)}
              strokeWidth={1}
              strokeOpacity={1}
              opacity={1}
            />
          </Chart>
        </ChartCanvas>
      </Container>
    );
  }
}

export default fitWidth(PreviewChart);
